import { IpaRow } from "./Ipa";
import { IpaChartProps } from "./IpaChart";

/** show the 5 basic IPA tone symbols & the most common combined tone symbols */
export function ToneChart(props: IpaChartProps) {
  return (
    <table>
      <thead>
        <tr>
          <th>basic</th>
          <th colSpan={3}>combos</th>
        </tr>
      </thead>
      <tbody>
        <IpaRow symbols={['˥', '˦˨', '˧˨', '˩˨']} chartProps={props} />
        <IpaRow symbols={['˦', '˨˦', '˥˦', '˦˥']} chartProps={props} />
        <IpaRow symbols={['˧', '˥˩', '˧˩', '˧˦']} chartProps={props} />
        <IpaRow symbols={['˨', '˩˥', '˦˧', '˨˦˨']} chartProps={props} />
        <IpaRow symbols={['˩', '˨˧', '˧˥', '˦˨˦']} chartProps={props} />
      </tbody>
    </table>
  )
}
